import { Injectable, inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { NavigationUtilService } from '../services/navigation-util.service';

@Injectable({
  providedIn: 'root'
})
export class CmRedirectGuard implements CanActivate {
  private navigationUtil = inject(NavigationUtilService);

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const cmPath = route.paramMap.get('cmpath') || '';
    this.navigationUtil.gotoCM(window.location, cmPath);
    return false;
  }
}
